import * as PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../../UI/Button/Button';
import editDeleteAddressActions from '../../../../actions/addressActions/editDeleteAddressActions';
import {hideOverlay, showOverlay} from '../../../../actions/overlay-actions';
import Translation from '../../../../lang/Translation';
import {isMobile} from '../../../../selectors/DeviceSelectors';
import {getSelectedDeliveryCountry} from '../../../../selectors/selectors';
import Spacing from '../../../../style-helper/Spacing';
import AddressAsText from '../../../address/AddressAsText/AddressAsText';
import {TooltipAndOverlayIDs} from '../../../detailed-tooltip/TooltipLibrary';
import CheckoutOverlay from '../../CheckoutOverlay';

const useStyles = createUseStyles({
  contentWrapper: {
    padding: [Spacing.triple, Spacing.double],
  },
  addressContainer: {
    backgroundColor: '#f2f2f2',
    padding: Spacing.double,
    margin: [Spacing.triple, 0, Spacing.quad],
  },
  saveButton: {
    marginBottom: Spacing.double,
  },
});

export function DeleteAddressOverlay(props) {
  const classes = useStyles();
  
  const handleDeleteAddressClick = () => {
    props.deleteAddress(props.addressId, props.deliveryCountry);
  };
  
  return (
    <CheckoutOverlay
      popup
      stickyScaleToContentMobile
      ordersummary
      nopadding
      minheight
      title="checkout.delivery.deleteAddress.overlay.title"
      className="DeleteAddressOverlay__form"
    >
      <div className={classes.contentWrapper} data-test="successText">
        <Translation>checkout.delivery.deleteAddress.overlay.warningText</Translation>
  
        <div className={classes.addressContainer}>
          <AddressAsText
            {...props.fieldValues}
            addressId={props.addressId}
          />
        </div>
        
        <div className={classes.buttonContainer}>
          <Button
            primary
            fullWidth={!props.isMobile}
            id="confirmDeleteAddress"
            onClick={handleDeleteAddressClick}
            className={classes.saveButton}
          >
            <Translation>checkout.delivery.deleteAddress.overlay.deleteConfirmation</Translation>
          </Button>
  
          <Button
            secondary
            fullWidth={!props.isMobile}
            id="closeDeleteAddressOverlay"
            onClick={() => (props.isMobile ? props.showOverlay(TooltipAndOverlayIDs.EDIT_DELETE_ADDRESS, props)
              : props.hideOverlay())}
          >
            <Translation>btn.cancel.text</Translation>
          </Button>
        </div>
      </div>
    </CheckoutOverlay>
  );
}

DeleteAddressOverlay.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldValues: PropTypes.object.isRequired,
  addressId: PropTypes.string.isRequired,
  deliveryCountry: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  
  // Actions
  deleteAddress: PropTypes.func.isRequired,
  showOverlay: PropTypes.func.isRequired,
  hideOverlay: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  fieldValues: state.address.deliveryAddressList.addresses[ownProps.addressId],
  deliveryCountry: getSelectedDeliveryCountry(state),
  isMobile: isMobile(state),
});

const mapDispatchToProps = {
  showOverlay,
  hideOverlay,
  deleteAddress: editDeleteAddressActions.deleteAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAddressOverlay);
